import { render, staticRenderFns } from "./CompanyDemandsContainer.vue?vue&type=template&id=639dc994&"
import script from "./CompanyDemandsContainer.vue?vue&type=script&lang=js&"
export * from "./CompanyDemandsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports